module.exports = (__parcel__import__("5npuk")).then(() => parcelRequire('fyWP3'));